<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_worker") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
          />

          <!-- Start:: first_name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.client-name')"
            v-model.trim="data.first_name"
            required
          />
          <!-- End:: first_name Input -->
          <base-select-input
            col="6"
            @input="getStores"
            :optionsList="sections"
            :placeholder="$t('PLACEHOLDERS.section')"
            v-model="data.section"
            required
          />
          <base-select-input
            col="6"
            :optionsList="stores"
            :placeholder="$t('PLACEHOLDERS.store')"
            v-model="data.store"
            required
          />

          <!-- Start:: last_name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <!-- End:: last_name Input -->

          <!-- Start:: mobile Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.mobile"
            required
          />
          <!-- End:: mobile Input -->

          <!-- Start:: Password Input -->
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Deactivate Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateArea",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        first_name: null,
        last_name: null,
        mobile: null,
        section: null,
        store: null,
        email: null,
        mobile: null,
        // active: true,
      },
      sections: [],
      stores: [],

      // End:: Data Collection To Send
    };
  },

  computed: {
    allTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.subscription"),
          value: "subscription",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.commission"),
          value: "commission",
        },
      ];
    },
  },

  methods: {
    async getSections() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories?page=0&limit=0`,
        });

        this.sections = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getStores() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `stores?page=0&limit=0&category=${this.data.section.id}`,
        });

        this.stores = res.data.data.data?.map((ele) => ({
          id: ele.id,
          name: ele.store_name,
        }));
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      // Start:: Append Request Data
      REQUEST_DATA.append("name", this.data.first_name);
      REQUEST_DATA.append("mobile", this.data.mobile);
      if (this.data.email) {
        REQUEST_DATA.append("email", this.data.email);
      }
      REQUEST_DATA.append("category_id", this.data.section?.id);
      REQUEST_DATA.append("store_id", this.data.store?.id);
      // REQUEST_DATA.append("is_active", +this.data.active);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `workers`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/Workers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    this.getSections();
  },
};
</script>
